module.exports = __webpack_public_path__ + "img/bankrefah.e77fcbd.png";